import React from 'react';

// tabs 每一项结构：[order_status值, 显示文案, 额外筛选参数(可选)]
// 注意："已取消"和"已退款"这两个tab的 order_status 值都是 'cancelled'，
// 靠额外参数（payment_status）才能区分开，所以：
// 1. key 不能再用 val 本身（会重复），改用 val+label 拼出唯一key
// 2. 高亮判断也不能只比 val，要连 extraParams 一起比对，否则两个tab会同时高亮或者分不清选中哪个
const OrderFilterTabs = ({ tabs, filterStatus, filterExtraParams, onChange, onRefresh }) => {
  const extraParamsKey = (params) => JSON.stringify(params || null);

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {tabs.map(([val, label, extraParams]) => {
        const isActive =
          filterStatus === val &&
          extraParamsKey(extraParams) === extraParamsKey(filterExtraParams);

        return (
          <button
            key={`${val}-${label}`}
            onClick={() => onChange(val, extraParams)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              isActive ? 'bg-blue-600 text-white' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'
            }`}
          >
            {label}
          </button>
        );
      })}
      <button onClick={onRefresh} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
        刷新
      </button>
    </div>
  );
};

export default OrderFilterTabs;